import { defineComponent } from 'vue'
import classNames from 'classnames'
import './MainLayout.scss'

export const MainLayout = defineComponent({
  name: 'MainLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <section {...attrs} class={classNames('main-layout', attrs.class as string)}>
        {slots.default?.()}
      </section>
    )
  },
})
